import { Button } from "antd";

import {
  BUTTON_SHAPES,
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";
import { BaseIconButtonProps } from "./types";

import "./styles.css";

const BaseIconButton = ({
  icon,
  ariaLabel,
  onClick,
  variant = BUTTON_VARIANTS.PRIMARY,
  size = BUTTON_SIZES.LARGE,
  shape = BUTTON_SHAPES.SQUARE,
  className,
  disabled = false,
  loading = false,
}: BaseIconButtonProps) => {
  const classes = `base-icon-button base-button-${variant} base-icon-button-${size} base-icon-button-${shape} ${disabled || loading ? "base-button-disabled" : ""} ${className || ""}`;

  return (
    <Button
      className={classes}
      icon={icon}
      shape={shape === BUTTON_SHAPES.CIRCLE ? "circle" : "default"}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      aria-label={ariaLabel}
    />
  );
};

export default BaseIconButton;
